import { makeObservable, observable, runInAction, reaction, toJS } from 'mobx';

class dynamicSelectStore {
  data={};
  options={};
  constructor(dataset) {
    makeObservable(this, {
      data: observable,
      options: observable,
    });

    if(dataset.data) {
      this.data = dataset.data;
    }

    this.options.inputName=dataset.inputName
    if(dataset.placeholder) {
      this.options.placeholder = dataset.placeholder
    }

    if(dataset.exportIndex) {
      this.options.exportIndex=dataset.exportIndex;
    }

    if(dataset.useTime) {
      this.options.useTime=dataset.useTime=='true'?true:false;
    } else {
      this.options.useTime=false;
    }

    if(dataset.data) {
      const json=JSON.parse(dataset.data);
      console.log('json',json);
      if(json) {
        this.data=json;
      }
    }
  }
}

export default dynamicSelectStore;